import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import type { StudyView } from "@shared/types";
import { StatusPill } from "../components/Status";

export function Studies() {
  const [studies, setStudies] = useState<StudyView[]>([]);
  useEffect(() => {
    api<{ studies: StudyView[] }>("/api/studies").then((r) => setStudies(r.studies)).catch(() => setStudies([]));
  }, []);
  return (
    <section className="page-hero">
      <div className="wrap">
        <p className="kicker">Studies</p>
        <h1>Public flood studies in the corpus</h1>
        <div className="results">
          {studies.map((s) => (
            <Link className="result" key={s.id} to={`/study/${s.slug}`}>
              <div className="record-meta">
                <span>{s.publishedAt}</span>
                <span>{s.systemName}</span>
                <StatusPill status={s.status} />
                <StatusPill status={s.epistemic} />
              </div>
              <h3>{s.title}</h3>
              <p className="muted">{s.summary}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
